var naturesEs = {
    "100": "Fuerte",       // Hardy
    "101": "Huraña",       // Lonely
    "102": "Audaz",        // Brave
    "103": "Firme",        // Adamant
    "104": "Pícara",       // Naughty
    "105": "Osada",        // Bold
    "106": "Dócil",        // Docile
    "107": "Plácida",      // Relaxed
    "108": "Agitada",      // Impish
    "109": "Floja",        // Lax
    "110": "Miedosa",      // Timid
    "111": "Activa",       // Hasty
    "112": "Seria",        // Serious
    "113": "Alegre",       // Jolly
    "114": "Ingenua",      // Naive
    "115": "Modesta",      // Modest
    "116": "Afable",       // Mild
    "117": "Mansa",        // Quiet
    "118": "Tímida",       // Bashful
    "119": "Alocada",      // Rash
    "120": "Calmada",      // Calm
    "121": "Amable",       // Gentle
    "122": "Grosera",      // Sassy
    "123": "Cauta",        // Careful
    "124": "Rara"          // Quirky
};
export default naturesEs;